document.addEventListener('DOMContentLoaded', function() {
  // Znajdź wszystkie tagi <p> na stronie
  const paragraphs = document.querySelectorAll('p');

  // Przejdź przez każdy znaleziony tag
  paragraphs.forEach(p => {
    // Sprawdź, czy tag jest pusty (nie ma tekstu ani innych elementów w środku)
    // .trim() usuwa białe znaki, więc <p>  </p> też zostanie usunięty
    if (p.innerHTML.trim() === '' || p.innerHTML === '&nbsp;') {
      // Jeśli jest pusty, usuń go
      p.parentNode.removeChild(p);
    }
  });
});
